import { Inject, Injectable } from '@angular/core';
declare var grecaptcha: any;

export enum RecaptchaType {
  GENERAL = 'general',
  TRANSACTION = 'transaction'
}

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  _config: any;

  constructor(@Inject('APP_ENVIRONMENT') private environment: any) {
    this._config = environment
  }

  executeNewRecaptcha(action: string, type: RecaptchaType = RecaptchaType.GENERAL): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        if (!grecaptcha || !grecaptcha.enterprise) {
          resolve('');
        }
        
        const siteKey = this.getSiteKeyByType(type);

        // console.log("executeNewRecaptcha siteKey: ", siteKey)
        grecaptcha.enterprise.ready(() => {
          grecaptcha.enterprise.execute(siteKey, { action: action })
          .then((token: string) => {
            resolve(token);
          })
          .catch((error: any) => {
            resolve('Recaptcha not loaded');
          });
        });
      } catch (error) {
        resolve('Recaptcha not loaded');
      }
    });
  }

    private getSiteKeyByType(type: RecaptchaType): string {
      // console.log("getSiteKeyByType type: ", type)
    switch (type) {
      case RecaptchaType.TRANSACTION:
        return this._config.RECAPTCHA_TRANSACTION_SITE_KEY || '6LdLEWUrAAAAAJAoTB_oavCjnHnZzOU3ZxAw7hhJ';
      case RecaptchaType.GENERAL:
      default:
        return this._config.RECAPTCHA_ENTERPRISE_SITE_KEY;
    }
  }
}
